export { default } from './SyncMigrationActionConfirmation';
